// packages/api-client/queries/certificationSteps/index.ts
import { useQuery, useMutation, } from "@tanstack/react-query";
export const createCertificationStepsQueries = (requests, queryClient) => ({
    useListCertificationSteps: (params, options = {}) => useQuery({
        queryKey: ["certification-steps", params],
        queryFn: async ({ queryKey }) => {
            const [_key, params] = queryKey;
            return requests.listCertificationSteps(params);
        },
        ...options,
    }),
    useFindCertificationStep: (params, options = {}) => useQuery({
        queryKey: ["certification-step", params],
        queryFn: async ({ queryKey }) => {
            const [_key, params] = queryKey;
            return requests.findCertificationStep(params);
        },
        ...options,
    }),
    useCreateCertificationStep: (options = {}) => useMutation({
        ...options,
        mutationFn: requests.createCertificationStep,
        onSuccess: (data, variables, context) => {
            queryClient.invalidateQueries({
                queryKey: ["certification-steps"],
            });
            options.onSuccess?.(data, variables, context);
        },
    }),
    useUpdateCertificationStep: (options = {}) => useMutation({
        ...options,
        mutationFn: requests.updateCertificationStep,
        onSuccess: (data, variables, context) => {
            queryClient.invalidateQueries({
                queryKey: ["certification-steps"],
            });
            options.onSuccess?.(data, variables, context);
        },
    }),
    useDeleteCertificationStep: (options = {}) => useMutation({
        ...options,
        mutationFn: requests.deleteCertificationStep,
        onSuccess: (data, variables, context) => {
            queryClient.invalidateQueries({
                queryKey: ["certification-steps"],
            });
            options.onSuccess?.(data, variables, context);
        },
    }),
    useStartPracticeStepRun: (options = {}) => useMutation({
        ...options,
        mutationFn: requests.startPracticeStepRun,
        onSuccess: (data, variables, context) => {
            queryClient.invalidateQueries({
                queryKey: ["certification-steps"],
            });
            options.onSuccess?.(data, variables, context);
        },
    }),
    useStartTheoryStepRun: (options = {}) => useMutation({
        ...options,
        mutationFn: requests.startTheoryStepRun,
        onSuccess: (data, variables, context) => {
            queryClient.invalidateQueries({
                queryKey: ["certification-steps"],
            });
            options.onSuccess?.(data, variables, context);
        },
    }),
    useSubmitCertificationStepExam: (options = {}) => useMutation({
        ...options,
        mutationFn: requests.submitCertificationStepExam,
        onSuccess: (data, variables, context) => {
            queryClient.invalidateQueries({
                queryKey: ["certification-steps"],
            });
            options.onSuccess?.(data, variables, context);
        },
    }),
});
//# sourceMappingURL=index.js.map